module.exports = __webpack_public_path__ + "static/media/others_web2.fa4219b3.jpg";